<template>
  <div class="celebrity main-top-border pt20">
    <div class="main-wrap">
      <div class="celebrity-main">
        <!--<div class="celebrity-title">-->
          <!--<span class="fl title-l">推荐名人</span>-->
          <!--<span class="fr title-r"><i class="el-icon-question"></i>如何成为名人</span>-->
        <!--</div>-->
        <ul class="celebrities">
          <li
                  class="item"
                  v-for="(item,index) in celebrityList"
                  :key="index">
            <div class="photo">
              <el-image class="img" :src="$common.imgPath(item.celebrityImg?item.celebrityImg:item.headImg)" :alt="item.id" lazy fit="cover"></el-image>
            </div>
            <p class="name">{{item.celebrityName?item.celebrityName:item.shopName}}</p>
            <!--<p class="flag">{{item.celebrityDesc}}</p>-->
            <p class="duty"><!--兰花协会<span class="dian"></span>-->{{item.celebrityIdentity}}</p>
            <p class="article-num">共有{{item.newsCount}}篇文章</p>
            <button type="button" class="btn-follow" @click="$router.push({path:`/celebrity/detail/${item.shopId}`})">查看详情</button>
          </li>
        </ul>
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page="current"
                :page-size="size"
                layout=" prev, pager, next,total, jumper"
                style="text-align: center;padding:20px;"
                :hide-on-single-page="isOnePage"
                :total="totalPage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
    import {getCelebrityPage} from '../../api/shop'
  export default {
    data(){
        return {
            current:1,
            size:15,
            totalPage:0,
            isOnePage:false,
            celebrityList:[]
        }
    },
      components:{
      },
      created () {
      },
      mounted(){
          this.getCelebrityList();
      },
      methods:{
          handleCurrentChange(current){
              this.current=current;
              this.getCelebrityList();
          },
          getCelebrityList(){
              getCelebrityPage({
                  current:this.current,
                  size:this.size,
                  rank:2
              }).then(res=>{
                  const {total,records} = res.data;
                  this.celebrityList=records;
                  this.totalPage=total;
                  this.isOnePage=this.totalPage<=this.size?true:false;
              })
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .celebrity{
    .celebrity-main{
      width:1082px;
      margin:0 auto;
      .celebrity-title{
        height:80px;
        line-height:80px;
        background-color:$main-color;
        color:#ffffff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        .title-l{
          font-size:22px;
          font-weight:600;
          padding-left:95px;
        }
        .title-r{
          font-size:18px;
          padding-right:40px;
        }
      }
      .celebrities{
        overflow: hidden;
        padding-bottom:24px;
        .item{
          position: relative;
          &+.item{
            margin-left:16px;
          }
          &:nth-child(3n+1){
            margin-left:0;
          }
          float: left;
          width:348px;
          height:324px;
          background-color:#F7F7F7;
          border:1px solid #EBEBEB;
          text-align: center;
          margin-top:80px;
          .photo{
            width:100px;
            height:100px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
            margin:-46px auto 0;
            background-color:$main-color;
            .img{width:100%;
              height:100%;
              -webkit-border-radius: 50%;
              -moz-border-radius: 50%;
              border-radius: 50%;
            }
          }
          .name{
            font-size:22px;
            color:#000000;
            padding:13px 0 16px;
            font-weight:600;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .flag,.duty{
            font-size:16px;
            color:#666666;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .duty{
            /*height: 100px;*/
            padding: 0 40px;
            .dian{
              display: inline-block;
              margin:0 8px;
              width:5px;height:5px;
              -webkit-border-radius: 50%;
              -moz-border-radius: 50%;
              border-radius: 50%;
              background-color: #666666;
            }
          }
          .article-num{
            color: #57BE81;
            position: absolute;
            width: 100%;
            bottom: 116px;
          }
          .btn-follow{
            width:90px;
            height:40px;
            color:#ffffff;
            background-color:$main-color;
            -webkit-border-radius: 23px;
            -moz-border-radius: 23px;
            border-radius: 23px;
            margin-top:36px;
            font-size:14px;
            position: absolute;
            left:50%;
            margin-left:-45px;
            bottom:47px;
          }
        }
      }
    }
  }

</style>
